import { Category } from '@/models/category.model';
import { Address, Sorting } from '@/models/info.model';
import { Media } from '@/models/media.model';
import { TranslationState } from '@/models/translation.model';
import { UserLabel } from './label.model';

export enum ActionType {
  Action = 'action',
  Initiative = 'initiative',
  Tips = 'tips',
}

export interface Action {
  id: number;
  title: string;
  description: string;
  shortDescription: string;
  difficulty: number;
  impact: number;
  type: ActionType;
  published: boolean;
  sorting: Sorting;
  mainCategory: Category;
  categories: Category[];
  steps: Step[];
  media: Media[];
  notRelevantForlabels: UserLabel[];
  translated?: TranslationState;
}

export interface Step {
  id?: number;
  index: number;
  action?: Action;
  description: string;
  address: Address;
}
